import { render, staticRenderFns } from "./TabRequests.vue?vue&type=template&id=fe282d58"
import script from "./TabRequests.vue?vue&type=script&lang=js"
export * from "./TabRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports